var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiRrTimeFast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.584,
    height: 15.589,
    viewBox: "0 0 15.584 15.589",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-time-fast",
    transform: "translate(0 0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5817",
    "data-name": "Path 5817",
    d: "M5.844,23.3H.649a.649.649,0,1,1,0-1.3H5.844a.649.649,0,1,1,0,1.3Z",
    transform: "translate(0 -7.717)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5818",
    "data-name": "Path 5818",
    d: "M4.545,19.3H.649a.649.649,0,1,1,0-1.3h3.9a.649.649,0,1,1,0,1.3Z",
    transform: "translate(0 -6.314)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5819",
    "data-name": "Path 5819",
    d: "M3.247,15.3H.649a.649.649,0,1,1,0-1.3h2.6a.649.649,0,1,1,0,1.3Z",
    transform: "translate(0 -4.912)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5820",
    "data-name": "Path 5820",
    d: "M8.457,15.552a.65.65,0,1,1-.058-1.3A6.493,6.493,0,1,0,1.341,7.2.649.649,0,1,1,.048,7.082,7.792,7.792,0,1,1,8.516,15.55C8.5,15.552,8.476,15.552,8.457,15.552Z",
    transform: "translate(-0.016)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5821",
    "data-name": "Path 5821",
    d: "M11.649,6A.649.649,0,0,0,11,6.649V9.9a.649.649,0,0,0,.19.459L13.138,12.3a.649.649,0,1,0,.918-.918L12.3,9.627V6.649A.649.649,0,0,0,11.649,6Z",
    transform: "translate(-3.857 -2.106)",
    fill: "#bbc6d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrTimeFast);
export default __webpack_public_path__ + "static/media/fi-rr-time-fast.59377038.svg";
export { ForwardRef as ReactComponent };